import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Router, Route, Switch } from "react-router-dom";
import history from "./history";
import Project1 from "./pages/project1";

import App from "./App";

ReactDOM.render(
  <Router history={history}>
    <Switch>
      <Route exact path={process.env.PUBLIC_URL + "/"} component={App} />
      <Route exact path="/social-media-app" component={Project1} />
    </Switch>
  </Router>,
  document.querySelector("#root")
);
